
    <div>
      <label i18n="@@MandatoryComments" class="textColour" [ngStyle]="{'border-color':buttonColor}">
       {{ data.action === 'complete' ? 'Reviewer Comments' : 'Approver Comments' }}
      </label>
      <span class="example-spacer"></span>
    </div>

<!-- Reviewer Info  -->
<div class="review-info mb-2" *ngIf="reviewerName">
  <div>
    <strong class="block">Reviewer: {{ reviewerName }}</strong>
    <strong class="block">Reviewed Date: {{ reviewedDate }}</strong>
  </div>
</div>

<!-- Approver comment (approve action) -->
<div *ngIf="data.action === 'approve' && comment" 
     class="comment-list mb-2">
  {{ comment }}
</div>

<mat-dialog-content [formGroup]="commentsForm" class="dialog-content">
  <div class="form-field-wrapper">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Enter your comments</mat-label>
    <textarea
      matInput
      formControlName="comments"
      rows="4"
      maxlength="250"
      class="comment-textarea"
    ></textarea>
    <mat-hint align="end">
      {{ commentsForm.get('comments')?.value?.length || 0 }}/250
    </mat-hint>
    <mat-error *ngIf="commentsForm.get('comments')?.hasError('required')">
      Comments are required
    </mat-error>
  </mat-form-field>
  </div>
</mat-dialog-content>


<!-- <mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button color="warn" (click)="cancel()">
    Cancel
  </button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="commentsForm.invalid"
    (click)="submit()"
  >
    Submit
  </button>
</mat-dialog-actions> -->

<!-- Footer Buttons -->
  <div style="height:3vh">
    <div class="row mb-1 topRowMargins" style="position:sticky;left:0;bottom:0;width:100%">
      <div class="col-lg-5"></div>
      <div class="col-lg-7" style="text-align: end; margin-left: 10%">
        <button i18n="@@TargetCancel" type="button" (click)="cancel()"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;" [style.border-color]="buttonColor">
          Cancel
        </button>
        <button i18n="@@regenerateWordButton" type="button" (click)="submit()"
                [style.background-color]="buttonColor"
                class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
          Submit
        </button>
      </div>
    </div>
  </div>
